export default "__VITE_ASSET__d1ae0a26__"